import "./Skill.css";
const Skills = () => {
  return (
    <div id="skills">
      <h1 className="mt-5 pt-4 text-center" data-aos="fade-down">
        Skills
      </h1>
      <div className="text-center mb-5">
        <small>These are my abilities to enhance built projects.</small>
      </div>
      <div className="container">
        <div className="row row-cols-sm-3 mx-auto  row-cols-2 w-100">
          {skill.map((data, key) => {
            return (
              <>
                <div
                  key={key}
                  className="my-3 px-sm-5"
                  data-aos={key % 2 === 0 ? "fade-left" : "fade-right"}
                >
                  <div className="d-flex justify-content-between">
                    <span>{data.label}</span> <span>{data.rating * 10}%</span>
                  </div>
                  <div className="progress-bar">
                    <span style={{ width: `${data.rating * 10}%` }}></span>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Skills;
const skill = [
  { label: "React Js", rating: "9.5" },
  { label: "Express Js", rating: "9" },
  { label: "Node Js", rating: "8.5" },
  { label: "Spring Boot", rating: "8" },
  { label: "Hibernate", rating: "9" },
  { label: "Spring", rating: "7.5" },
  { label: "Java Collection Framework", rating: "9.5" },
  { label: "MongoDB", rating: "8" },
  { label: "MYSQL", rating: "8.5" },
  { label: "PostgresSQL", rating: "6.5" },
  { label: "Java", rating: "9.6" },
  { label: "JavaScript", rating: "9" },
  { label: "CSS", rating: "9.5" },
  { label: "HTML", rating: "9.7" },
];
